enum JobInfoTagTypeEnum {
  LOCATION = 'LOCATION',
  CREATED_AT = 'CREATED_AT',
  LEVEL = 'LEVEL',
  OCCUPATION_TYPE = 'OCCUPATION_TYPE',
}

export default JobInfoTagTypeEnum;
